import { ArrowBack, ArrowForward, Edit } from "@material-ui/icons";

const icons = {
	ArrowForward: <ArrowForward />,
	ArrowBack: <ArrowBack />,
	Edit: <Edit />,
	Blank: <></>
};
export default icons;
